import React, { Component } from "react";
//import url from 'url';
//import isEqual from 'lodash.isequal';
import { NavLink } from "react-router-dom";
//import NavLink from './NavLink';
import { withRouter } from 'react-router';
import { AppContext } from "../context/AppContext";
import { isEmpty } from "../helpers";
import iconCloseburger from "../img/icon-closeburger.png";
//import superCloud from '../img/super-cloud.png';
//import superWordBlack from "../img/super-word-rgb.png";
import superSOMLogo from "../img/SOM-LOGO.png";
import { compose } from "redux";
import localize from "../hoc/localize";

class Sidebar extends Component {

    handleClickOnNavbar = (e) => {
        // prevent clicks on navbar from propagating to the parent app-container element.
        // why? when navbar is open, app-container (which is a parent for everything on screen) is given a click event that will close the navbar.
        // we don't want clicks on the navbar to propagate up this parent. (which would result in closing the menu)
        e.stopPropagation();
    }
    handleToggleMenu = e => {
        this.context.handleToggleMenu();
    };

    // handle clicking on a menu item
    handleLinkClick = (e, navLink) => {

        const sourceNavLinks = this.context.state.navLinks;

        // if link has a submenu but does not have its own link, then ...
        // expand the submenu if currently closed,
        // otherwise close the submenu if currently expanded
        if (navLink.hasOwnProperty('submenu') && !navLink.hasOwnProperty('link')) {

            //const sourceNavLinks = this.context.state.navLinks;

            // this.context.state.navLinks has a reference to navLink, so if I modify the latter, the former will get its updates as well
            // toggle the menu item
            navLink.expanded = isEmpty(navLink.expanded) ? true : !navLink.expanded;

            // save the updates into state
            this.context.setState({
                navLinks: sourceNavLinks,
            });

            e.preventDefault();
            return;
        } else {
            // link is a real link
            sourceNavLinks.forEach(nl => { nl.active = false; });
            if (navLink.parentIdx !== undefined) // navLink is a sub menu, then set its parent to active
                sourceNavLinks[navLink.parentIdx].active = true;
            else
                navLink.active = true;

            // once we click on menu item, then close the navbar
            this.context.setState({
                navLinks: sourceNavLinks,
                isNavBarVisible: false,
            });
        }
    };

    handleClickExpander = (e, navLink) => {
        //console.log('handleClickExpander', navLink);

        const sourceNavLinks = this.context.state.navLinks;
        let target = sourceNavLinks.find(sourceNavLink => sourceNavLink === navLink);

        target.expanded = isEmpty(target.expanded) ? true : !target.expanded;

        this.context.setState({
            navLinks: sourceNavLinks
        });

        // prevent click from bubbling up
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();

        // prevent ourselves from navigating to the hyperlink target
        e.preventDefault();

        // toggle the submenu
        // find a reference to the menu item
    }
    render() {

        // get css class for the menu container, based on whether or not it is currently open
        let menuClass = "";
        if (this.context.state.isNavBarVisible !== undefined) {
            menuClass = this.context.state.isNavBarVisible ? "visible " : "";
        }

        let navLinks = this.context.state.navLinks;

        //<img src={superCloud} className="logo-super" alt="" />
        //<img src={superWordBlack} className="word-super" alt="Super" />
        //SOM
        return (
            <div className={`app-navbar ${menuClass}`} onClick={this.handleClickOnNavbar}>
                <div className="title">
                    <img
                        className="closer"
                        src={iconCloseburger}
                        onClick={this.handleToggleMenu}
                        alt="X"
                    />

                    <img src={superSOMLogo} className="super-som-logo" alt="Super SOM" />
                </div>

                <div className="links">
                    <ul className="nav">
                        {navLinks &&
                            navLinks.map(
                                (navLink, index) => {

                                    // get the classes we need to use
                                    const expandable = (navLink.hasOwnProperty('submenu'));
                                    const expanded = navLink.expanded;

                                    // check if the link is supposed to take the user anywhere else

                                    let liClass = navLink.active ? 'active' : '';
                                    let linkClass = '';

                                    let linkTo = {};
                                    if (navLink.link) {
                                        //linkTo = navLink.link;
                                        linkTo = {
                                            pathname: navLink.link,
                                            search: navLink.linkParams
                                        }

                                    } else {
                                        //linkTo = "#nowhence";
                                        linkTo = {
                                            pathname: "#nowhence"
                                        }
                                    }


                                    // check if there is a submenu, and style appropriately
                                    let arrowIcon = '';
                                    if (expandable) {
                                        linkClass += 'expandable ';
                                        arrowIcon = require(`../img/icon-arrowdown.png`);
                                    }
                                    if (expanded) {
                                        linkClass += 'expanded ';
                                        arrowIcon = require(`../img/icon-arrowup.png`)
                                    }

                                    return (
                                        <li className={liClass} key={index}>
                                            <NavLink
                                                onClick={
                                                    (e) => { this.handleLinkClick(e, navLink) }
                                                }
                                                data-index={index}
                                                key={index}
                                                to={linkTo}
                                                {...(navLink.exact ? { exact: true } : undefined)}
                                                className={linkClass}
                                            >
                                                <span
                                                    className='nav-item'
                                                >
                                                    <img
                                                        src={require(`../img/icon-${navLink.icon}.png`)} alt=""
                                                    />

                                                    <span className="nav-item-label">
                                                        {
                                                            this.props.returnLocalizedString(navLink.label)
                                                        }
                                                    </span>

                                                    {!isEmpty(arrowIcon) && (
                                                        <div className="expando">
                                                            <img src={arrowIcon} className="expander" onClick={(e) => {
                                                                this.handleClickExpander(e, navLink)
                                                            }
                                                            } alt="" />
                                                        </div>
                                                    )}
                                                </span>
                                            </NavLink>
                                            {
                                                // if there is a submenu then render that submenu
                                                (navLink.hasOwnProperty('submenu')) ? (
                                                    <div className="nav-submenu">
                                                        {
                                                            // render out the submenu menu links
                                                            navLink.submenu.map((subNavLink, subNavLinkIndex) => {
                                                                //const subNavLinkUrl = url.parse(subNavLink.link).pathname;


                                                                return (
                                                                    <NavLink
                                                                        key={subNavLinkIndex}
                                                                        to={{
                                                                            pathname: subNavLink.link,
                                                                            search: subNavLink.linkParams
                                                                        }}
                                                                        {...(subNavLink.exact ? { exact: true } : undefined)}

                                                                        onClick={
                                                                            (e) => { this.handleLinkClick(e, subNavLink) }
                                                                        }
                                                                        // isActive={(match, location) => {
                                                                        //     if (subNavLink.label === "Manage Superadmins") {
                                                                        //         debugger;

                                                                        //     }
                                                                        //     return false;
                                                                        // }}
                                                                        data-index={subNavLinkIndex}
                                                                        data-parentindex={index}
                                                                    >
                                                                        <span className="nav-item">
                                                                            <span className="nav-item-mini-icon">
                                                                                {false && subNavLink.icon}
                                                                            </span>
                                                                            <span className="nav-item-label">
                                                                                {
                                                                                this.props.returnLocalizedString(subNavLink.label)
                                                                                }
                                                                            </span>
                                                                        </span>
                                                                    </NavLink>
                                                                );
                                                            })}

                                                    </div>
                                                ) : (<React.Fragment />)
                                            }
                                        </li>
                                    )

                                }
                            )}
                    </ul>
                </div>

                <div className="org-name">
                    {this.context.state.orgName}
                </div>
            </div>
        )
    }
}
export default compose(localize, withRouter)(Sidebar);
Sidebar.contextType = AppContext;
//export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js